import { IconProps } from "./types";

/** Generic person/customer glyph — used wherever a customer or contact name
 * needs a leading icon (e.g. TrackingHeader's customer row). */
export const UserIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4974 12.7783C6.72352 12.7783 3.5 13.3733 3.5 15.7533C3.5 18.1342 6.70339 18.7502 10.4974 18.7502C14.2713 18.7502 17.4948 18.1561 17.4948 15.7752C17.4948 13.3943 14.2923 12.7783 10.4974 12.7783Z"
      fill={color}
      fillOpacity={0.4}
    />
    <path
      d="M10.4977 10.511C13.0685 10.511 15.1282 8.45041 15.1282 5.88052C15.1282 3.31064 13.0685 1.25 10.4977 1.25C7.92782 1.25 5.86719 3.31064 5.86719 5.88052C5.86719 8.45041 7.92782 10.511 10.4977 10.511Z"
      fill={color}
    />
  </svg>
);
